export default __webpack_public_path__ + "static/media/desktop_welcome_grid.a3e8c4e8.png";